import queryString from 'query-string';

import type {
  DatetimeNoTzString,
  DatetimeString,
  IanaTimezone,
} from '#/types/TypedDateString';

import { getJson } from './http/getJson';

export function getUserTimezone(): IanaTimezone | null {
  if (!Intl?.DateTimeFormat) {
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = -offsetMinutes / 60;
    return `UTC${offsetHours >= 0 ? '+' : ''}${offsetHours}`;
  }

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (timezone === 'Etc/Unknown') return null;

  return timezone;
}

export async function getTimezoneFromLatLng(
  lat: number,
  lng: number,
): Promise<string> {
  return getJson<{
    utc: DatetimeString;
    atPosition: DatetimeNoTzString;
    timezone: IanaTimezone;
  }>(
    queryString.stringifyUrl({
      url: '/data/time/at-position',
      query: { lat, lng },
    }),
  ).then(({ timezone }) => timezone);
}
